export class ScreenConstants {
  static MOBILE_S_MAX_WIDTH = 425;
  static MOBILE_MAX_WIDTH = 768;
  static DESKTOP_MIN_WIDTH = 1023;
}
